import React from "react";
import { Link } from "react-router-dom";
import { Scale, X, ArrowRight } from "lucide-react";
import { useCompare } from "@/context/CompareContext";
import { assetUrl } from "@/lib/api";

export function CompareBar() {
  const { items, count, removeCompare, clearCompare } = useCompare();
  if (count === 0) return null;

  return (
    <div data-testid="compare-bar"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-3xl">
      <div className="flex items-center gap-3 rounded-2xl bg-ink text-white shadow-2xl border border-white/10 px-4 py-3">
        <div className="flex items-center gap-1.5 text-sm font-semibold shrink-0">
          <Scale size={18} className="text-coral" /> Compare ({count})
        </div>
        <div className="flex items-center gap-2 overflow-x-auto flex-1 sn-scroll-x">
          {items.map((p) => (
            <div key={p.id} className="relative shrink-0">
              <img src={assetUrl(p.image)} alt={p.name} className="h-11 w-11 rounded-lg object-cover" />
              <button data-testid={`compare-bar-remove-${p.id}`} onClick={() => removeCompare(p.id)}
                className="absolute -top-1.5 -right-1.5 h-5 w-5 grid place-items-center rounded-full bg-coral text-white">
                <X size={12} />
              </button>
            </div>
          ))}
        </div>
        <button data-testid="compare-bar-clear" onClick={clearCompare}
          className="text-xs text-white/60 hover:text-white shrink-0">Clear</button>
        <Link data-testid="compare-bar-view" to="/compare"
          className="flex items-center gap-1.5 rounded-xl bg-coral px-4 py-2 text-sm font-semibold hover:bg-white hover:text-ink transition-colors shrink-0">
          Compare <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
